/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';
import { connect } from 'react-redux';

import { showNotification } from 'Store/Notification/Notification.action';
import { showPopup } from 'Store/Popup/Popup.action';
import { getGuestQuoteId } from 'Util/Cart';
import componentLoader from 'Util/componentLoader';
import { fetchMutation, fetchQuery } from 'Util/Request';

import PostNordQuery from '../../query/PostNord.query';
import { PostNordComponent } from './PostNord.component';
import { POST_NORD_POPUP_ID } from './PostNord.config';

export const PostNordDispatcher = componentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    '../../store/PostNord/PostNord.dispatcher'
), 2);
/** @namespace Bodymod/PostNord/Component/PostNord/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    point: state.PostNordReducer.point,
    points: state.PostNordReducer.points,
    postcode: state.CheckoutReducer.currentZipcode,
    street: state.CheckoutReducer.street_0
});

/** @namespace Bodymod/PostNord/Component/PostNord/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    showNotification: (type, message) => dispatch(showNotification(type, message)),
    setPostNordPoint: (point) => PostNordDispatcher.then(
        ({ default: dispatcher }) => dispatcher.setPostNordPoint(point, dispatch)
    ),
    setPostNordAddressPoints: (points) => PostNordDispatcher.then(
        ({ default: dispatcher }) => dispatcher.setPostNordAddressPoints(points, dispatch)
    ),
    showPopup: (payload) => dispatch(showPopup(POST_NORD_POPUP_ID, payload)),
    hidePopup: () => dispatch(showPopup('', {}))
});

/** @namespace Bodymod/PostNord/Component/PostNord/Container */
export class PostNordContainer extends PureComponent {
    static propTypes = {
        showPostNordPopUp: PropTypes.func.isRequired,
        setPostNordPoint: PropTypes.func.isRequired,
        point: PropTypes.object.isRequired,
        isWidget: PropTypes.bool.isRequired,
        showPopup: PropTypes.func.isRequired,
        setPostNordAddressPoints: PropTypes.func.isRequired,
        showNotification: PropTypes.func.isRequired,
        points: PropTypes.array.isRequired,
        postcode: PropTypes.string.isRequired,
        street: PropTypes.string.isRequired,
        setSelectedPostNordPoint: PropTypes.func.isRequired,
        hidePopup: PropTypes.func.isRequired
    };

    fieldRef = createRef();

    state = {
        customPostCode: '',
        customStreet: '',
        isLoading: false,
        isPointLoading: false,
        hasError: false
    };

    containerFunctions = {
        showPostNordPopUp: this.showPostNordPopUp.bind(this),
        setSelectedPostNordPoint: this.setSelectedPostNordPoint.bind(this),
        onPostCodeChange: this.onPostCodeChange.bind(this),
        onStreetChange: this.onStreetChange.bind(this),
        setPointLoading: this.setPointLoading.bind(this)
    };

    componentDidUpdate() {
        const { postcode } = this.props;
        const { customPostCode } = this.state;

        if (customPostCode || postcode) {
            this.setState({ hasError: false });
        }
    }

    containerProps() {
        const {
            point, points, postcode, street, setSelectedPostNordPoint
        } = this.props;
        const {
            customPostCode, customStreet, isLoading, isPointLoading, hasError
        } = this.state;

        return {
            points,
            point,
            customPostCode,
            postcode,
            customStreet,
            street,
            isLoading,
            isPointLoading,
            setSelectedPostNordPoint,
            hasError
        };
    }

    setPointLoading(isPointLoading) {
        this.setState({ isPointLoading });
    }

    showPostNordPopUp() {
        this.getPostNordPoints();
    }

    onPostCodeChange(event) {
        if (event.target.value) {
            this.setState({ hasError: false });
        }
        this.setState({ customPostCode: event.target.value });
    }

    onStreetChange(event) {
        this.setState({ customStreet: event.target.value });
    }

    noPointFoundNotification() {
        const { showNotification } = this.props;
        showNotification('info', __('No pickup point found for current address!'));
    }

    async getPostNordPoints() {
        const { setPostNordAddressPoints, postcode, showPopup } = this.props;
        const { customPostCode } = this.state;
        if (!customPostCode && !postcode) {
            this.setState({ hasError: true });
            return null;
        }
        try {
            this.setState({ isLoading: true });
            const { postNordGet: { pickupPoints } } = await fetchQuery(PostNordQuery.getPostNordPoints(
                { postcode: customPostCode || postcode, street: '' }
            ));

            this.setState({ isLoading: false });
            setPostNordAddressPoints(pickupPoints);
            if (!pickupPoints.length) {
                this.noPointFoundNotification();
            } else {
                showPopup({ title: __('Select pickup point') });
            }

            return null;
        } catch (error) {
            this.setState({ isLoading: false });
            console.error(error);
            return null;
        }
    }

    async setSelectedPostNordPoint(point) {
        const {
            address, zipcode, city, name, carrier_code, number
        } = point;
        const pickupPoint = `${address},${zipcode},${city},${name},${carrier_code},${number}`;
        const cartId = getGuestQuoteId();
        const { hidePopup } = this.props;
        try {
            this.setPointLoading(true);
            await fetchMutation(
                PostNordQuery.getPostNordMutation({ pickupPoint, cartId })
            );

            this.setPointLoading(false);
            hidePopup();
        } catch (error) {
            this.setPointLoading(false);
            console.error(error);
        }
    }

    render() {
        return (
            <PostNordComponent
              { ...this.containerProps() }
              { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PostNordContainer);
